import { render, staticRenderFns } from "./wsjk.vue?vue&type=template&id=4f8831bd&scoped=true&"
import script from "./wsjk.vue?vue&type=script&lang=js&"
export * from "./wsjk.vue?vue&type=script&lang=js&"
import style0 from "./wsjk.vue?vue&type=style&index=0&id=4f8831bd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8831bd",
  null
  
)

export default component.exports